import React from "react";
import { Navigate } from "react-router-dom";

const PublicRouter = ({ authenticated, component: Component }) => {
  const link = window.sessionStorage.getItem("route");
  console.log(link);

  return !authenticated ? (
    Component
  ) : (
    <Navigate to={link ? link : "/Dashboard/"} />
  );
};

export default PublicRouter;
